<script setup lang="ts">
// A RIST input's or destination's link settings: the profile, the recovery
// buffer and the main profile's pre-shared key (write-only, as an SRT
// passphrase).
import type { RIST } from '../../api'

const rist = defineModel<RIST>({ required: true })
</script>

<template>
    <details open>
        <summary>RIST options</summary>
        <div class="grid grid-cols-2 gap-2.5">
            <div class="mb-2.5">
                <label>Profile</label
                ><select v-model="rist.profile" data-test="rist-profile">
                    <option :value="undefined">main (one port, encryption)</option>
                    <option value="simple">simple (RTP on an even port, RTCP on the next)</option>
                    <option value="advanced">advanced</option>
                </select>
            </div>
            <div class="mb-2.5">
                <label>Recovery buffer (ms) <span class="text-fg-3">(empty = 1000)</span></label
                ><input v-model.number="rist.buffer_ms" type="number" min="50" max="30000" placeholder="1000" />
            </div>
        </div>
        <div v-if="rist.profile !== 'simple'" class="grid grid-cols-2 gap-2.5">
            <div class="mb-2.5">
                <label>Pre-shared key <span class="text-fg-3">(optional, 8-127 characters)</span></label
                ><input
                    v-model="rist.secret"
                    type="password"
                    autocomplete="new-password"
                    data-test="rist-secret"
                    title="Kept on the node and never shown again: type a new one to change it, clear it to remove it"
                />
            </div>
            <div class="mb-2.5">
                <label>Encryption</label
                ><select v-model="rist.key_size">
                    <option :value="undefined">AES-128</option>
                    <option :value="256">AES-256</option>
                </select>
            </div>
        </div>
        <p class="text-xs text-fg-3">
            Both ends must use the same profile, key and encryption. The buffer is how long lost packets can still be
            asked for again: about four round trips is plenty.
        </p>
    </details>
</template>
